/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosInstance } from 'axios';
import { ngrokHeadersConfigDevelopment } from './ngrok-headers';

let httpClient: any = null;
export const getHttpClient = () => httpClient as AxiosInstance;

export const createAuthClient = (args: {
	token: string;
}) => {

	const result = axios.create({
		headers: {
			...ngrokHeadersConfigDevelopment(),
			'Authorization': `Bearer ${args.token}`
		}
	});

	httpClient = result;
};